import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../../constants/ActionTypes";
import ApiUrls from "../../../../constants/ApiUrls";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import ProductInsuranceFactory from "../../../../factories/product/ProductInsuranceFactory";
import { apiRequest } from "../../api/actions";
import {
  createErrorNotification,
  getNotification,
} from "../../notification/actions";
import { getSessionData } from "../../sessionData/actions";
import {
  enrichProductInsuranceAction,
  setProductInsurance,
} from "./actions";
import { setLoader } from "../../ui/actions";

export const getProductInsuranceMiddleware: Middleware =
  (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
    next(action);
    switch (action.type) {
    case ActionTypes.PRODUCT.FETCH_PRODUCT_INSURANCE:
      next(
        apiRequest(
          null,
          "GET",
          ApiUrls.PRODUCT_INSURANCE,
          {
            erpCode: store.getState().productData.product.item.erpCode,
          },
          null,
          MiddlewareEntities.PRODUCT_INSURANCE,
          {}
        )
      );
      next(setLoader(true, MiddlewareEntities.PRODUCT_INSURANCE));
      break;
    case `${MiddlewareEntities.PRODUCT_INSURANCE} ${ActionTypes.API_SUCCESS}`:
      next(enrichProductInsuranceAction(action.payload.data));
      next(getSessionData(action.payload.data.session));
      next(
        getNotification(
          action.payload.data.session.flashMessages,
          MiddlewareEntities.PRODUCT_INSURANCE
        )
      );
      next(setLoader(false, MiddlewareEntities.PRODUCT_INSURANCE));
      break;
    case `${MiddlewareEntities.PRODUCTS} ${ActionTypes.API_ERROR}`:
      next(setLoader(false, MiddlewareEntities.PRODUCTS));
      next(
        createErrorNotification(
          action.payload.data,
          MiddlewareEntities.PRODUCTS
        )
      );
      break;
    }
  };

export const enrichProductInsuranceMiddleware: Middleware =
  (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
    next(action);

    if (action.type === ActionTypes.PRODUCT.ENRICH_PRODUCT_INSURANCE) {
      const { productInsurance } = action.payload;
      const { productData } = store.getState().productData;
      const productInsuranceEntity = ProductInsuranceFactory.createFromResponse(
        productInsurance,
        Number(productData.contract)
      );
      next(setProductInsurance(productInsuranceEntity));
    }
  };

export const productInsuranceMiddleware = [
  getProductInsuranceMiddleware,
  enrichProductInsuranceMiddleware,
];
